package feature.mediaFile.event

class MediaFileEvent() {
    companion object{
        const val CREATE = "CREATE_MEDIA_FILE"
        const val UPDATE = "UPDATE_MEDIA_FILE"
        const val RETRIEVE = "RETRIEVE_MEDIA_FILE"
        const val DELETE = "DELETE_MEDIA_FILE"
    }

}